import { useQuery } from "@tanstack/react-query";

import { BlowAcceptabilityProps } from "../../pages/PatientPage/components/MeasurementModal/components/BlowAcceptabilitySection";
import { spirometryService } from "../../services/spirometryService";

export function useArtiQSpirometryData(spirometryId: number[]) {
  const { data, isError, isFetching, refetch, isRefetching } = useQuery({
    queryKey: ["spirometry-artiq-data", spirometryId],
    queryFn: async () => {
      const { data } = await spirometryService.getArtiqSessionData(
        spirometryId[0]
      );

      const blowAcceptability = <BlowAcceptabilityProps[]>[];
      const flowVolumeAxes = <any>[];
      const timeVolumeAxes = <any>[];

      data.spirometryTests.forEach((spirometryTest: any) => {
        const fvcAcceptabilityReasonParsed =
          spirometryTest.fvc_acceptability_reason &&
          spirometryTest.fvc_acceptability_reason.split(";");

        blowAcceptability.push({
          fvcAcceptabilityReason: fvcAcceptabilityReasonParsed,
          fvcAcceptability: spirometryTest.fvc_acceptability,
          fev1Acceptability: spirometryTest.fev1_acceptability,
        });
        flowVolumeAxes.push(spirometryTest.flow_volume_axes);
        timeVolumeAxes.push(spirometryTest.time_volume_axes);
      });

      const parsedArtiQSpirometryData = {
        blowAcceptability,

        fev1Grade: data.bestOfSession?.fev1Grade,
        fvcGrade: data.bestOfSession?.fvcGrade,

        flowVolumeAxes,
        timeVolumeAxes,

        bestValues: {
          fev1: data.bestOfSession.fev1,
          predictedFev1: data.bestOfSession.percentPredictedFev1,
          fvc: data.bestOfSession.fvc,
          predictedFvc: data.bestOfSession.percentPredictedFvc,
          fev1fvc: `${Math.round(data.bestOfSession.fev1Fvc * 100)}%`,
          pef: data.bestOfSession.pef,
        },

        percentPredictedWarning: data.percentPredictedWarning,
        spirometryTests: data.spirometryTests,
      };

      return parsedArtiQSpirometryData;
    },
    refetchOnMount: "always",
    // spirometryId is an array, and an empty array is truthy — so `!!spirometryId`
    // was always true and fired a request with spirometryId[0] === undefined
    // (e.g. when the selection is cleared after changing a filter), hitting
    // GetSessionBySpirometryId/undefined/ → 404. Guard on actual content.
    enabled: spirometryId.length > 0 && spirometryId[0] != null,
  });

  return { artiQData: data, isError, isFetching, refetch, isRefetching };
}
